import service from 'utils/axios'
import { VERSIONS } from 'utils/version'

export const getAllUnityConfiguration = (appid) => service.get(`${VERSIONS.V1}/unityconfiguration/getallunityconfiguration`, { params: { appid } })